<template>
    <div class="tw-text-white">
        <a :href="href" @click.prevent="toggle" class="sidebar-nav-menu tw-cursor-pointer tw-relative" :class="{ 'open': open, 'active':(href && active) }">
            <template v-if="href">
                <span ref="quicksearch" class="tw-mr-3 tw-absolute tw-inset-y-0 tw-right-0 tw-inline-flex tw-items-center tw-justify-center">
                    <span class="tw-border tw-rounded-lg tw-inline-flex tw-items-center tw-justify-center tw-px-2 search-icon tw-group hover:tw-border-white" style="height: 25px;">
                        <i class="fa fa-search tw-text-xs search-icon group-hover:tw-text-white"></i>
                    </span>
                </span>
            </template>
            <template v-else>
                <i class="fa fa-angle-left sidebar-nav-indicator sidebar-nav-mini-hide"></i>
            </template>

            <i class="sidebar-nav-icon" :class="icon"></i>
            <span class="sidebar-nav-mini-hide">{{label}}</span>
        </a>

        <transition name="slide">
            <ul v-if="open">
                <!-- For nav items that have multiple links, like Courses, having another slot that holds a quicksearch might be useful -->
                <slot></slot>
            </ul>
        </transition>
    </div>
</template>

<script>
export default {
    name: "SidebarDropdown",

    props: {
        label: {
            required: true,
            type: String
        },
        paths: {
            default: [],
            type: Array
        },
        icon: {
            default: '',
            type: String
        },
        href: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            disabled: false,
            open: false,
            hover: false
        }
    },

    computed: {
        active() {
            for(let path of this.paths) {
                if(window.location.pathname.startsWith(path)) {
                    return true;
                }
            }

            return false;
        }
    },

    created() {
        if(this.active && this.href == null) {
            this.disabled = true;
            this.open = true;
        }
    },

    methods: {
        toggle(event) {
            if(!this.disabled) {
                // If the click target was not the quicksearch icon, and href is not null, then redirect
                if(this.href && !this.$refs.quicksearch.contains(event.target)) {
                    return window.location.href = this.href;
                }

                this.open = !this.open;

                if(this.open) {
                    // When opening the dropdown, send an event to its siblings to close
                    EventBus.$emit('sidebar-dropdown-click');

                    // Listen for other dropdowns opening
                    EventBus.$on('sidebar-dropdown-click', this.close);
                } else {
                    // When closing the dropdown, remove the event listener
                    EventBus.$off('sidebar-dropdown-click', this.close);
                }
            }
        },

        close() {
            if(!this.disabled) {
                this.open = false;

                EventBus.$off('sidebar-dropdown-click', this.close);
            }
        },

        redirect() {
            window.location.href = this.href;
        }
    }
}
</script>

<style scoped>
ul {
    display: revert;
}

.search-icon {
    color: #9097A1 !important;
    border-color: #9097A1 !important;
}

</style>